import React from 'react';

const PDF = ({ url, style }) => {
  return <object data={url} type="application/pdf" width="100%" height="100%" style={style} />;
};

export default PDF;
